import React, { useState } from 'react';
import cardImage from '../img/envision/qualityimges/cardsimg/quality1.JPG'; // Replace with the correct path to your image
import cardImage2 from '../img/envision/qualityimges/cardsimg/quality2.JPG'; // Replace with the correct path to your image
import cardImage3 from '../img/envision/qualityimges/cardsimg/quality3.JPG'; // Replace with the correct path to your image

const Aboutusobjectives = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div style={{ textAlign: 'center' }}>
            <h1 style={{ textAlign: 'center', marginBottom: '0px' }}>
                Our <span style={{ color: 'rgb(16 131 158)' }}>Objectives</span>
            </h1>

            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '50px',
                    padding: '20px',
                    backgroundColor: '#fff',
                }}
            >
                {/* Card 1 */}
                <div
                    style={{
                        width: '250px',
                        height: '290px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 0 ? 'rgb(7 134 159)' : '',
                    }}
                    onMouseEnter={() => setHoveredIndex(0)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <img
                        src={cardImage}
                        alt="Card 1"
                        style={{
                            width: '100%',
                            height: '183px',
                            objectFit: 'cover',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            transition: 'opacity 0.3s ease',
                            opacity: hoveredIndex === 0 ? 0.8 : 1,
                        }}
                    />
                    <h1>Achivement</h1>
                    <p style={{ marginBottom: '10px',color:'#000' }}>Achieving the best performance within the industries we serve</p>
                </div>

                {/* Card 2 */}
                <div
                    style={{
                        width: '250px',
                        height: '290px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 1 ? 'rgb(7 134 159)' : '',
                    }}
                    onMouseEnter={() => setHoveredIndex(1)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <img
                        src={cardImage2}
                        alt="Card 2"
                        style={{
                            width: '100%',
                            height: '183px',
                            objectFit: 'cover',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            transition: 'opacity 0.3s ease',
                            opacity: hoveredIndex === 1 ? 0.8 : 1,
                        }}
                    />
                    <h1>Improvements</h1>
                    <p style={{ marginBottom: '10px',color:'#000'  }}>Constant Improvements of stakeholders engagement scores</p>
                </div>

                {/* Card 3 */}
                <div
                    style={{
                        width: '250px',
                        height: '290px',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textAlign: 'center',
                        transition: 'background-color 0.3s ease, opacity 0.3s ease',
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        overflow: 'hidden',
                        backgroundColor: hoveredIndex === 2 ? 'rgb(7 134 159)' : '',
                    }}
                    onMouseEnter={() => setHoveredIndex(2)}
                    onMouseLeave={() => setHoveredIndex(null)}
                >
                    <img
                        src={cardImage3}
                        alt="Card 3"
                        style={{
                            width: '100%',
                            height: '183px',
                            objectFit: 'cover',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            transition: 'opacity 0.3s ease',
                            opacity: hoveredIndex === 2 ? 0.8 : 1,
                        }}
                    />
                    <h1>Skill Matrix</h1>
                    <p style={{ marginBottom: '10px',color:'#000'  }}> Continuous building of skill evolving market dynamics</p>
                </div>


            </div>
        </div>
    );
};

export default Aboutusobjectives;
